// extracted by mini-css-extract-plugin
export default {"alert-success":"rgb(30, 133, 59)","preRunLabel":"styles_preRunLabel__qPj3J"};